import { render, staticRenderFns } from "./OpeningTimes.vue?vue&type=template&id=cb55c0ca&"
import script from "./OpeningTimes.vue?vue&type=script&lang=ts&"
export * from "./OpeningTimes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports